import "./LinkImage.scss";

const LinkImage = ({ arr, dataSize, dataType }) => {
    let size = dataSize;
    const mass = [];
    for (let i = 0; i < Math.ceil(arr.length / size); i++) {
        mass[i] = arr.slice(i * size, i * size + size);
    }

    const clickHandler = (e) => {
        e.preventDefault();
        console.log(1);
        document
            .querySelectorAll(".link-image-download")
            .forEach(async (el) => el.click());
    };
    return (
        <div className="list">
            <div className="list__wrap">
                {mass.map((elem, index) => (
                    <div
                        key={index}
                        className={
                            dataType == "grid"
                                ? "piece-wrap"
                                : "piece-wrap piece-wrap-flex"
                        }
                    >
                        {elem.map((el, index) => (
                            <a
                                className="link-image-download"
                                key={index}
                                href={el}
                                download={`${index}.jpeg`}
                            >
                                <img src={el} />
                                <span>
                                    <img
                                        className="download-svg"
                                        src="https://teamhulo.github.io/img-slicer/download.svg"
                                        alt=""
                                    />
                                </span>
                            </a>
                        ))}
                    </div>
                ))}
            </div>
            {!!mass.length && (
                <a
                    className="btn-down-all btn"
                    onClick={clickHandler}
                    download="images.zip"
                >
                    {" "}
                    download all
                </a>
            )}
        </div>
    );
};

export default LinkImage;
